import { render, staticRenderFns } from "./BranchesTab.vue?vue&type=template&id=411d29ca&scoped=true&"
import script from "./BranchesTab.vue?vue&type=script&lang=ts&"
export * from "./BranchesTab.vue?vue&type=script&lang=ts&"
import style0 from "./BranchesTab.vue?vue&type=style&index=0&id=411d29ca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "411d29ca",
  null
  
)

export default component.exports